import { useMutation } from '@tanstack/vue-query';

import http from '@/services/http';
import { feedEndpoints, profiClient, unwrapBody } from '@/queries/feed/client';
import { getSessionServerId } from '@/services/session';

async function answerQuiz(payload) {
  const response = await http.post(feedEndpoints.quizAnswers, {
    ...payload,
    server_id: getSessionServerId() || undefined
  });
  return unwrapBody(response.data);
}

async function answerProfiwayQuiz({ resultId, questionId, answerId, userVariant }) {
  const body = userVariant ? { answer_id: answerId, user_variant: userVariant } : { answer_id: answerId };
  const response = await profiClient.post(feedEndpoints.profiwayAnswer, body, {
    params: {
      result_id: resultId,
      question_id: questionId,
      expand: 'questions.answers,resultAnswers'
    }
  });
  return unwrapBody(response.data);
}

async function finishProfiwayQuiz({ resultId }) {
  const response = await profiClient.post(
    feedEndpoints.profiwayFinish,
    {},
    {
      params: {
        result_id: resultId,
        expand: 'questions.answers,resultAnswers'
      }
    }
  );
  return unwrapBody(response.data);
}

export function useQuizAnswerMutation() {
  return useMutation({
    mutationFn: answerQuiz
  });
}

export function useProfiwayAnswerMutation() {
  return useMutation({
    mutationFn: answerProfiwayQuiz
  });
}

export function useFinishProfiwayMutation() {
  return useMutation({
    mutationFn: finishProfiwayQuiz
  });
}
